<template>
  <BaseModal
    :model-value="visible"
    title="Delete Document?"
    width="640px"
    :title-logo="alarmIcon"
    description="Are you sure you want to delete this document? This action cannot be undone."
    @update:model-value="(val) => !val && emit('close')"
    @close="emit('close')"
  >
    <template #footer>
      <div class="flex justify-between items-center w-full">
        <Button
          type="normal"
          color-type="none-stroke"
          @click="emit('close')"
        >
          Cancel
        </Button>
        <Button
          type="normal"
          color-type="red"
          :filled="false"
          @click="emit('delete')"
        >
          Delete Document
        </Button>
      </div>
    </template>
  </BaseModal>
</template>

<script setup>
import BaseModal from './BaseModal.vue'
import Button from '@/NewLibrary/Button.vue'
import alarmIcon from '@/assets/my-calendar/white-alarm.svg'

const emit = defineEmits(['close', 'delete'])
defineProps({
  visible: {
    type: Boolean,
    default: false
  }
})
</script>
